export const NOTIFICATIONS_COUNT_FEATURE_KEY = 'notificationsCount';

export interface NotificationsCountState {
  unreadCount: number;
  loading: boolean;
}

export const initialCountState: NotificationsCountState = {
  unreadCount: 0,
  loading: false
};
